import { Lightbulb } from 'lucide-react'
import { GRACKLE_COLORS, CATEGORICAL } from '@/lib/theme'

interface ProTipProps {
  children: React.ReactNode
}

export default function ProTip({ children }: ProTipProps) {
  return (
    <aside
      role="note"
      aria-label="Pro tip"
      className="flex gap-3 rounded-lg border p-3"
      style={{
        backgroundColor: CATEGORICAL.navy.tint,
        borderColor: CATEGORICAL.navy.solid,
        color: GRACKLE_COLORS.prussianBlue,
      }}
    >
      <Lightbulb
        className="h-5 w-5 shrink-0 mt-0.5"
        style={{ color: CATEGORICAL.navy.solid }}
        aria-hidden="true"
      />
      <div className="text-sm">{children}</div>
    </aside>
  )
}
